module.exports = require("./lkt-US");